<template lang="pug">
  v-col(class="text-center" :cols="cols")
    slot(name="default")
      video(width="200px" autoplay loop)
        source(:src="require('@/assets/logo-motion.webm')" type="video/webm")
      .caption.grey--text(v-if="!noCaption")
        | {{ JOKES[Math.floor(Math.random()*JOKES.length)] }}...
</template>

<script>

const JOKES = [
  'Рассчет вашего успеха',
  'Прогрев двигателей СДО',
  'Поиск свободного гнома',
  'Выход в атмосферу',
  'Сверхточный рассчет успеха',
  'Взлом баз данных фсб',
  'Поиск наилучшего решения',
  'Доставка пиццы',
  'Соединяем провода',
  'Крутим шестеренки',
  'Подготовка нейронных сетей',
  'Майнинг биткойна',
];

export default {
  name: 'SdoLoader',
  props: {
    cols: {
      type: String,
      default: '12',
    },
    noCaption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      JOKES,
    };
  },
};
</script>

<style scoped>

</style>
